import { gql } from '@apollo/client'

export const GET_USERS_ACCOUNT_SHARING = gql`
  query findAllUsersAccountSharing($query: UserQueryInput!) {
    findAllUsersAccountSharing(query: $query) {
      count
      items {
        id
        avatar
        firstName
        lastName
        email
        role
        purchases {
          active
          activeCount
          paused
          pausedCount
          expired
          expiredCount
        }
        isBlocked
        countOfRegion
        countOfBrowserId
      }
    }
  }
`
